export default {
  namespaced: true,
  state: {
    requests: 0
  },
  getters: {
    requestCount: state => state.requests
  },
  mutations: {
    increment(state) {
      state.requests++;
    },
    decrement(state) {
      state.requests--;

      if (state.requests < 0) {
        state.requests = 0;
      }
    }
  },
  actions: {
    increment({commit}) {
      commit('increment');
    },
    decrement({commit}) {
      commit('decrement');
    }
  }
}